// -------------------- Select Sizes --------------------

function selectSize(element) {
  const parentNodeSizes = element.parentNode.parentNode;

  //Se les quita el color a todas las tallas del producto
  const nodeListTallas = parentNodeSizes.querySelectorAll(
    ".size-option-steven"
  );

  nodeListTallas.forEach((talla) => {
    talla.classList.remove("size-option-steven-active");
  });

  //Se agrega el color a la talla seleccionada
  element.classList.add("size-option-steven-active");

  //Se agrega el sku seleccionado al parentNode
  parentNodeSizes.setAttribute("data-selected-sku", element.dataset.idSku);

  //Habilitar el botón de comprar
  const botonComprar = parentNodeSizes.querySelector(
    ".button-quickbuy-plp-steven"
  );
  botonComprar.style.backgroundColor = "#1a1a1a";
  botonComprar.innerText = "Comprar";
  botonComprar.style.color = "white";
  botonComprar.disabled = false;
}

// -------------------- Display Error Message --------------------

function displayErrorMessageQuickBuy(element) {
  const alreadyExists = element.querySelector(".error-message-plp-sizes");

  //Valida si el elemento ya existe
  if (!alreadyExists) {
    //crea el elemento
    const message = document.createElement("div");
    message.innerText = "Selecciona una talla";
    message.style.color = "red";
    message.classList.add("error-message-plp-sizes");
    element.prepend(message);

    //Se borra el elemento tras pasar cierta cantidad de segundos
    setTimeout(function () {
      const errorToEliminate = element.querySelector(
        ".error-message-plp-sizes"
      );
      errorToEliminate.remove();
    }, 3000);
  }
}

// -------------------- Product Added to cart --------------------

function displaySuccessMessage(element) {
  element.innerText = "Producto agregado";
  element.style.backgroundColor = "#ed145b";
}

// -------------------- Quickbuy button --------------------

function addToCartButton(idsku, quantity, button) {
  let formData = {
    items: [
      {
        id: idsku,
        quantity: quantity,
      },
    ],
  };

  //Llamada API
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      displaySuccessMessage(button);

      // Now I will do a get to show the itens from cart

      setTimeout(function () {
        jQuery.getJSON("/cart.js", function (cart) {
          let cartData = cart.items;
          document.dispatchEvent(
            new CustomEvent("cart:build", { bubbles: true })
          );
          document.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: false,
              detail: cartData,
            })
          );
        });
      }, 1000);
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

document.body.addEventListener("click", async (event) => {
  if (event.target.className === "size-option-steven") {
    selectSize(event.target);
    return;
  }

  if (event.target.className === "button-quickbuy-plp-steven") {
    const parentNode = event.target.parentNode;

    //Validar que ya se haya seleccionado una talla
    if (!parentNode.dataset.selectedSku) {
      displayErrorMessageQuickBuy(parentNode);
      return;
    }

    //Hacer llamado a API
    await addToCartButton(parentNode.dataset.selectedSku, 1, event.target);

    //Refrescar

    document.dispatchEvent(new CustomEvent("cart:build"));
  }
});
